import React from "react";
import IntegrationDetail from "./IntegrationDetail";

const IntegrationNafath = () => <IntegrationDetail integrationKey="nafath" />;

export default IntegrationNafath;
